<script>
	import { fly,fade } from 'svelte/transition';
	import { Icon } from '../feathericons.js';

  export let Title = "Unknown";

	/*
	fadeOutOnScroll(element) {
	if (!element) {
		return;
	}

	var distanceToTop = window.pageYOffset + element.getBoundingClientRect().top;
	var elementHeight = element.offsetHeight;
	var scrollTop = document.documentElement.scrollTop;
	*/

</script>

<div out:fade>

<h3>{@html Icon("map-pin")} {Title}</h3>
<slot name="blurb" />


{#if $$slots.playgrounds}

<h3>{@html Icon("smile")} Playground</h3>
<slot name="playgrounds" />

{/if}

{#if $$slots.foodanddrink}
<h3>{@html Icon("award")} Food and Drink</h3>
<slot name="foodanddrink" />
{/if}

{#if $$slots.walks}
<h3>{@html Icon("map")} Walks</h3>
<slot name="walks" />
{/if}

{#if $$slots.shops}
<h3>{@html Icon("gift")} Shops</h3>
<slot name="shops" />
{/if}

{#if $$slots.attractions}
<h3>{@html Icon("star")} Attractions</h3>
<slot name="attractions" />
{/if}

{#if $$slots.noteworthy}
<h3>{@html Icon("edit-3")} Noteworthy Places</h3>
<slot name="noteworthy" />
{/if}

</div>
